module.exports = __webpack_public_path__ + "img/client_top.313ba685.png";